import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AuthProvider } from './auth/AuthProvider.tsx';
import { UpdatePrompt } from './offline/UpdatePrompt.tsx';
import { ConfirmEmailPage } from './auth/ConfirmEmailPage.tsx';
import { LoginPage } from './auth/LoginPage.tsx';
import { RegisterPage } from './auth/RegisterPage.tsx';
import { RequireAuth } from './auth/RequireAuth.tsx';
import { AcceptInvitationPage } from './features/invitations/AcceptInvitationPage.tsx';
import { HomePage } from './features/home/HomePage.tsx';
import { ProfilePage } from './features/profile/ProfilePage.tsx';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UpdatePrompt />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/confirm-email" element={<ConfirmEmailPage />} />
          {/* Anonymous on purpose: the page explains the invitation and offers to sign
              in or sign up, rather than bouncing a new user to a bare login screen. */}
          <Route path="/invitations/accept" element={<AcceptInvitationPage />} />

          <Route
            path="/"
            element={
              <RequireAuth>
                <HomePage />
              </RequireAuth>
            }
          />

          <Route
            path="/profile"
            element={
              <RequireAuth>
                <ProfilePage />
              </RequireAuth>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
